import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useChartColors } from '../../hooks/useChartColors';

interface Category {
  key: string;
  label: string;
  color: string;
}

interface GroupedBarChartProps {
  data: Record<string, string | number>[];
  categories: Category[];
  nameKey: string;
  height?: number;
  valueFormatter?: (value: number) => string;
}

export function GroupedBarChart({
  data,
  categories,
  nameKey,
  height = 300,
  valueFormatter,
}: GroupedBarChartProps) {
  const colors = useChartColors();

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart data={data} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" stroke={colors.grid} horizontal={false} />
        <XAxis
          type="number"
          stroke={colors.axis}
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          type="category"
          dataKey={nameKey}
          stroke={colors.axis}
          fontSize={12}
          tickLine={false}
          axisLine={false}
          width={80}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: colors.tooltipBg,
            border: `1px solid ${colors.tooltipBorder}`,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            color: colors.text,
          }}
          formatter={(value: number, name: string) => [
            valueFormatter ? valueFormatter(value) : value.toLocaleString(),
            name,
          ]}
        />
        <Legend />
        {categories.map((cat) => (
          <Bar
            key={cat.key}
            dataKey={cat.key}
            name={cat.label}
            fill={cat.color}
            radius={[0, 6, 6, 0]}
            animationDuration={750}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
